import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './ContatoPage.css';

const ContatoPage = () => {
  // Form state
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    assunto: '',
    mensagem: '',
    aceiteTermos: false
  });

  // Error state
  const [errors, setErrors] = useState({});
  
  // Success message state
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    
    // Clear error when user types
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.nome.trim()) {
      newErrors.nome = 'Nome é obrigatório';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email é obrigatório';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }
    
    if (!formData.telefone.trim()) {
      newErrors.telefone = 'Telefone é obrigatório';
    }
    
    if (!formData.assunto) {
      newErrors.assunto = 'Selecione um assunto';
    }
    
    if (!formData.mensagem.trim()) {
      newErrors.mensagem = 'Mensagem é obrigatória';
    }
    
    if (!formData.aceiteTermos) {
      newErrors.aceiteTermos = 'Você deve aceitar os termos';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Show success message
      setSubmitSuccess(true);
      
      // Reset form
      setFormData({
        nome: '',
        email: '',
        telefone: '',
        empresa: '',
        assunto: '',
        mensagem: '',
        aceiteTermos: false
      });
      
      // Hide success message after 5 seconds
      setTimeout(() => {
        setSubmitSuccess(false);
      }, 5000);
    }
  };

  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <section className="contato-hero">
        <div className="contato-hero-content">
          <h1>Fale Conosco</h1>
          <p>
            Entre em contato com a nossa equipe e descubra como podemos ajudar 
            sua empresa com registros comerciais em todo o Brasil.
          </p>
        </div>
      </section>
      
      {/* Contact Info Section */}
      <section className="contato-info">
        <div className="contato-info-container">
          <div className="contato-info-item">
            <div className="contato-info-icon">📍</div>
            <h3>Endereço</h3>
            <p>Rua Paulistânia, 381, 1º andar, conjunto 11</p>
            <p>São Paulo - SP, CEP: 05440-000</p>
          </div>
          
          <div className="contato-info-item">
            <div className="contato-info-icon">📞</div>
            <h3>Telefone</h3>
            <p>
              <a href="tel:+551130000000">(11) 5128-0555</a>
            </p>
            {/* <p>
              <a href="tel:+5511900000000">(11) 90000-0000</a> (WhatsApp)
            </p> */}
          </div>
          
          <div className="contato-info-item">
            <div className="contato-info-icon">✉️</div>
            <h3>Email</h3>
            {/* <p>
              <a href="mailto:contato@veridicus.com.br">contato@veridicus.com.br</a>
            </p> */}
            <p>
              <a href="mailto:comercial@veridicus.com.br">comercial@veridicus.com.br</a>
            </p>
          </div>
          
          <div className="contato-info-item">
            <div className="contato-info-icon">🕒</div>
            <h3>Horário de Atendimento</h3>
            <p>Segunda a Sexta: 9h às 18h</p>
            <p>Sábados: 9h às 13h</p>
          </div>
        </div>
      </section>
      
      {/* Contact Form Section */}
      <section className="contato-form-section">
        <div className="contato-form-container">
          <div className="contato-form-header">
            <h2>Envie uma Mensagem</h2>
            <p>
              Preencha o formulário abaixo e nossa equipe entrará em contato 
              o mais breve possível. Todos os campos com * são obrigatórios.
            </p>
          </div>
          
          {submitSuccess && (
            <div className="success-message">
              <p>✅ Sua mensagem foi enviada com sucesso! Em breve entraremos em contato.</p>
            </div>
          )}
          
          <form className="contato-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nome">Nome Completo *</label>
                <input 
                  type="text" 
                  id="nome" 
                  name="nome" 
                  value={formData.nome}
                  onChange={handleChange}
                  className={errors.nome ? 'input-error' : ''}
                />
                {errors.nome && <span className="error-text">{errors.nome}</span>}
              </div>
              
              <div className="form-group">
                <label htmlFor="email">E-mail *</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? 'input-error' : ''}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="telefone">Telefone *</label>
                <input 
                  type="tel" 
                  id="telefone" 
                  name="telefone" 
                  value={formData.telefone}
                  onChange={handleChange}
                  className={errors.telefone ? 'input-error' : ''}
                />
                {errors.telefone && <span className="error-text">{errors.telefone}</span>}
              </div>
              
              <div className="form-group">
                <label htmlFor="empresa">Empresa</label>
                <input 
                  type="text" 
                  id="empresa" 
                  name="empresa" 
                  value={formData.empresa}
                  onChange={handleChange}
                />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="assunto">Assunto *</label>
              <select 
                id="assunto" 
                name="assunto" 
                value={formData.assunto}
                onChange={handleChange}
                className={errors.assunto ? 'input-error' : ''}
              >
                <option value="">Selecione um assunto</option>
                <option value="Abertura de Empresas">Abertura de Empresas</option>
                <option value="Alterações Contratuais">Alterações Contratuais</option>
                <option value="Certidões e Documentos">Certidões e Documentos</option>
                <option value="Arquivamento de Balanços">Arquivamento de Balanços</option>
                <option value="Consultoria Empresarial">Consultoria Empresarial</option>
                <option value="Baixa de Empresas">Baixa de Empresas</option>
                <option value="Outros Serviços">Outros Serviços</option>
              </select>
              {errors.assunto && <span className="error-text">{errors.assunto}</span>}
            </div>
            
            <div className="form-group">
              <label htmlFor="mensagem">Mensagem *</label>
              <textarea 
                id="mensagem" 
                name="mensagem" 
                rows="5" 
                value={formData.mensagem}
                onChange={handleChange}
                className={errors.mensagem ? 'input-error' : ''}
              ></textarea>
              {errors.mensagem && <span className="error-text">{errors.mensagem}</span>}
            </div>
            
            <div className="form-group checkbox-group">
              <div className="checkbox-container">
                <input 
                  type="checkbox" 
                  id="aceiteTermos" 
                  name="aceiteTermos" 
                  checked={formData.aceiteTermos}
                  onChange={handleChange}
                />
                <label htmlFor="aceiteTermos">
                  Concordo com a <a href="/privacidade" target="_blank">Política de Privacidade</a> *
                </label>
              </div>
              {errors.aceiteTermos && <span className="error-text">{errors.aceiteTermos}</span>}
            </div>
            
            <div className="form-group">
              <button type="submit" className="submit-button">
                Enviar Mensagem
              </button>
            </div>
          </form>
        </div>
      </section>
      
      {/* Map Section */}
      <section className="contato-map">
        <div className="map-container">
          <h2>Nossa Localização</h2>
          <div className="map-iframe">
            {/* Replace with your actual Google Maps iframe */}
            <div className="map-placeholder">
              <p>Mapa da Av. Paulista, 1000 - São Paulo/SP</p>
              <p>(Aqui seria exibido o mapa incorporado do Google Maps)</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="contato-cta">
        <div className="contato-cta-content">
          <h2>Precisando de Atendimento Urgente?</h2>
          <p>
            Para casos que demandam atenção imediata, entre em contato direto 
            com nossa equipe de plantão.
          </p>
          <div className="contato-cta-buttons">
            {/* <a href="tel:+5511900000000" className="cta-button primary">
              <span className="cta-icon">📱</span> WhatsApp Direto
            </a> */}
            <a href="mailto:comercial@veridicus.com.br" className="cta-button secondary">
              <span className="cta-icon">✉️</span> Email Prioritário
            </a>
          </div>
        </div>
      </section>
      
      <Footer />
    </>
  );
};

export default ContatoPage;